<template>
  <div class="bill-day-srm">
    <el-form :inline="true" :model="searchForm" ref="searchForm" :show-message="false">
      <el-form-item prop="period" label="结费账期" required>
        <el-date-picker
          v-model="searchForm.period"
          type="month"
          value-format="yyyy-MM"
          placeholder="结费账期"
          :clearable="false"
        />
      </el-form-item>
      <el-form-item prop="cityCode" label="城市" required>
        <el-select filterable v-model="searchForm.cityCode" @change="getSupplierList">
          <el-option
            v-for="item in citiesInfo"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="supplierId" label="供应商名称" required>
        <el-select filterable v-model="searchForm.supplierId" :disabled="!searchForm.cityCode">
          <el-option
            v-for="item in supplierList"
            :label="item.supplierName"
            :value="item.supplierId"
            :key="item.supplierId"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="bizLine" label="业务线" required>
        <el-select :clearable="false" v-model="searchForm.bizLine">
          <el-option
            v-for="item in commonOptionList.businessTypeList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="orderStatus" label="对账状态">
        <el-select clearable v-model="searchForm.orderStatus">
          <el-option
            v-for="item in statusList"
            :label="item.statusName"
            :value="item.statusId"
            :key="item.statusId"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="fetchList(true)"
          :loading="$refs.billDataList && $refs.billDataList.isLoading"
          :disabled="!this.searchForm.cityCode || !this.searchForm.supplierId"
          >搜索</el-button
        >
        <el-button
          @click="genSettlementBill"
          :loading="isCreating"
          :disabled="
            !$refs.billDataList ||
              !$refs.billDataList.dataList ||
              !$refs.billDataList.dataList.length
          "
          >确认账单</el-button
        >
      </el-form-item>
    </el-form>
    <div class="ui-card ui-card-body">
      <bill-data-list ref="billDataList" :show-sum="true" />
    </div>
  </div>
</template>

<script>
import billDataList from '@/components/srm/bill-data-list.vue'
import { dateFormat } from '@/utils'
import { computedCitiesInfo, commonOpt } from '@/mixins'
export default {
  mixins: [computedCitiesInfo, commonOpt],

  components: {
    billDataList,
  },

  data() {
    return {
      supplierList: [],
      statusList: [
        {
          statusName: '待提交',
          statusId: 0,
        },
        {
          statusName: '已提交',
          statusId: 1,
        },
      ],
      isCreating: false,
      searchForm: {
        supplierId: '',
        period: '',
        cityCode: '',
        bizLine: 1204,
        orderStatus: '',
      },
    }
  },

  computed: {
    supplierName() {
      const res = this.supplierList.find(value => {
        return value.supplierId === this.searchForm.supplierId
      })
      return res ? res.supplierName : ''
    },
  },

  created() {
    this.searchForm.cityCode = this.$store.state.currentCity
    this.searchForm.period = dateFormat(new Date(), 'yyyy-MM')
    this.getSupplierList()
    this.$debugVue('v_billDay', this)
    if (process.env.NODE_ENV === 'development') {
      this.searchForm.period = '2022-04'
      this.searchForm.cityCode = '010'
      this.searchForm.supplierId = '2690'
    }
  },

  methods: {
    // 调用组件方法
    fetchList(init) {
      if (this.searchForm.bizLine === 1203) {
        return this.$message.error('无电单车业务线权限')
      }
      if (!this.searchForm.cityCode) return
      this.$refs.billDataList.fetchList(init, {
        ...this.searchForm,
        supplierName: this.supplierName,
      })
    },

    // 获取供应商列表
    getSupplierList() {
      const params = {
        cityCode: this.searchForm.cityCode,
      }
      if (!params.cityCode) return
      this.fetch
        .get('srm_settlementQuerySuppliers', { params })
        .then(res => {
          this.supplierList = res.data || []
          this.searchForm.supplierId = this.supplierList[0] && this.supplierList[0].supplierId
        })
        .catch(res => {
          this.supplierList = []
          this.searchForm.supplierId = ''
        })
    },

    // 每月账期闭环结费确定后（当月27日9点）后才允许提交
    // 否则报错“当前时间未到结算账期（每月27日9点后），无法提交”
    disableGenSettlementBill() {
      const date = new Date()
      return date.getDate() < 27 || (date.getDate() === 27 && date.getHours() < 9)
    },

    // 确认账单
    genSettlementBill() {
      if (this.disableGenSettlementBill()) {
        return this.$message.error('当前时间未到结算账期（每月27日9点后），无法提交')
      }
      this.$msgbox
        .confirm(`结算单总金额为 ${this.$refs.billDataList.totalMoney}`, '确定吗？', {
          type: 'warning',
        })
        .then(() => {
          const params = { ...this.searchForm }
          delete params.orderStatus
          this.isCreating = true
          this.fetch
            .post('srm_settlementOrderCreate', params)
            .then(res => {
              this.isCreating = false
              this.$msgbox.alert(`生成成功，结算单号：${res.data || ''}`, '', {
                type: 'success',
                showClose: false,
              })
              this.fetchList()
            })
            .catch(res => {
              this.isCreating = false
            })
        })
        .catch(() => {
          //
        })
    },
  },
}
</script>
